module.exports = __webpack_public_path__ + "static/media/addIcon.20162328.png";